




































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import InjuryForm from '@/classes/InjuryForm';
import InjuryDocument from '@/classes/InjuryDocument';
import authorize, { Office, authorizeMap } from '@/services/Authorize';
import api from '@/services/api';
import { phoneFormatter } from '@/services/inputTools';
import { StudentProfile, IStudentProfile } from '@/classes/StudentProfile';
import UserProfile from '@/classes/UserProfile';
import binaryDownload from '@/services/BinaryDownloader';
import 'bootstrap';
import bootbox from 'bootbox';
import _ from 'underscore';
import { NAME_REGEX, PHONE_REGEX } from '@/validation';
import Person from '@/classes/InjuryForm/Person';
import Witness from '@/classes/InjuryForm/Witness';

@Component
export default class InjuryReportForm extends Vue {
  public $refs!: {
    fileInput: any;
  };
  @Prop() public id!: number;
  @Prop({ default: false }) public view!: boolean;
  @Prop({ default: false }) public edit!: boolean;

  public form: InjuryForm = new InjuryForm({});
  public documents: InjuryDocument[] = [];
  public removedDocuments: number[] = [];
  public centerSelected: string | null = null;
  public isClicked: boolean = false;

  public lookupPressed: boolean = false;
  public studentFound: boolean = false;
  public addingAsNewStudent: boolean | null = null;

  public employeeSelected: boolean = true;

  public file: File | null = null;

  public tabIndex: number = 0;

  public resetStudentForm() {
    if (this.form && this.form.student) {
      this.form.student.firstName = undefined;
      this.form.student.middleName = undefined;
      this.form.student.lastName = undefined;
      this.form.student.suffix = undefined;
      this.form.student.studentId = undefined;
      this.form.student.dolId = undefined;
      this.form.student.jobCorpCenterId = undefined;
      this.form.jobCorpsCenterId = undefined;
      this.lookupPressed = false;
      this.studentFound = false;
      this.addingAsNewStudent = null;
    }
  }

  get isStudentFound() {
    if (this.studentFound) {
      return 'Student found.';
    } else {
      return this.newStudentFeedback;
    }
  }

  get studentEmployeeList() {
    return [
      {
        value: 'employee',
        text: 'Employee'
      },
      {
        value: 'student',
        text: 'Student'
      }
    ];
  }

  get isEmployeeReport(): boolean {
    if (this.form && this.form.injuredPerson) {
      return this.form.injuredPerson === 'employee';
    } else {
      return false;
    }
  }

  get isStudentReport(): boolean {
    if (this.form && this.form.injuredPerson) {
      return this.form.injuredPerson === 'student';
    } else {
      return false;
    }
  }

  get studentFirstName(): string {
    return (((this.form || {}).student || {}).firstName || '').trim();
  }

  set studentFirstName(firstName: string) {
    if (this.form && this.form.student) {
      this.form.student.firstName = firstName;
    }
  }

  get studentFirstNameIsValid(): boolean {
    return !_(this.studentFirstName).isEmpty() && NAME_REGEX.test(this.studentFirstName);
  }

  get studentMiddleName(): string {
    return (((this.form || {}).student || {}).middleName || '').trim();
  }

  set studentMiddleName(middleName: string) {
    if (this.form && this.form.student) {
      this.form.student.middleName = middleName;
    }
  }

  get studentMiddleNameIsValid(): boolean | null {
    // Middle name is optional, so don't show the invalid feedback if not provided
    if (_(this.studentMiddleName).isEmpty()) {
      return null;
    }

    return NAME_REGEX.test(this.studentMiddleName);
  }

  get studentLastName(): string {
    return (((this.form || {}).student || {}).lastName || '').trim();
  }

  set studentLastName(lastName: string) {
    if (this.form && this.form.student) {
      this.form.student.lastName = lastName;
    }
  }

  get studentLastNameIsValid(): boolean {
    return !_(this.studentLastName).isEmpty() && NAME_REGEX.test(this.studentLastName);
  }

  get supervisor(): Person {
    return ((this.form || {}).supervisorReport || {}).supervisor || {};
  }

  get supervisorFirstName(): string {
    return (this.supervisor.firstName || '').trim();
  }

  set supervisorFirstName(firstName: string) {
    this.supervisor.firstName = firstName;
  }

  get supervisorFirstNameIsValid(): boolean {
    return !_(this.supervisorFirstName).isEmpty() && NAME_REGEX.test(this.supervisorFirstName);
  }

  get supervisorLastName(): string {
    return (this.supervisor.lastName || '').trim();
  }

  set supervisorLastName(lastName: string) {
    this.supervisor.lastName = lastName;
  }

  get supervisorLastNameIsValid(): boolean {
    return !_(this.supervisorLastName).isEmpty() && NAME_REGEX.test(this.supervisorLastName);
  }

  get supervisorTitle(): string {
    return (this.supervisor.title || '').trim();
  }

  set supervisorTitle(title: string) {
    this.supervisor.title = title;
  }

  get supervisorTitleIsValid(): boolean {
    return !_(this.supervisorTitle).isEmpty();
  }

  get supervisorPhone(): string {
    return (this.supervisor.officePhone || '').trim();
  }

  set supervisorPhone(phone: string) {
    this.supervisor.officePhone = phone;
  }

  get supervisorPhoneIsValid(): boolean {
    return !_(this.supervisorPhone).isEmpty() && PHONE_REGEX.test(this.supervisorPhone);
  }

  get witness(): Witness {
    const witnesses = ((this.form || {}).witnesses || []) as Witness[];
    return (_(witnesses).first() || {}) as Witness;
  }

  get witnessFirstName(): string {
    return (this.witness.firstName || '').trim();
  }

  set witnessFirstName(firstName: string) {
    this.witness.firstName = firstName;
  }

  get witnessFirstNameIsValid(): boolean | null {
    if (this.form.noWitness) {
      return null;
    }

    return !_(this.witnessFirstName).isEmpty() && NAME_REGEX.test(this.witnessFirstName);
  }

  get witnessMiddleName(): string {
    return (this.witness.middleName || '').trim();
  }

  set witnessMiddleName(middleName: string) {
    this.witness.middleName = middleName;
  }

  get witnessMiddleNameIsValid(): boolean | null {
    if (this.form.noWitness || _(this.witnessMiddleName).isEmpty()) {
      return null;
    }

    return NAME_REGEX.test(this.witnessMiddleName);
  }

  get witnessLastName(): string {
    return (this.witness.lastName || '').trim();
  }

  set witnessLastName(lastName: string) {
    this.witness.lastName = lastName;
  }

  get witnessLastNameIsValid(): boolean | null {
    if (this.form.noWitness) {
      return null;
    }

    return !_(this.witnessLastName).isEmpty() && NAME_REGEX.test(this.witnessLastName);
  }

  get jobCorpCenters() {
    return _(this.$store.getters.getJobCorpsCentersAllowed).sortBy((c) => c.name);
  }

  public get studentTabComplete() {
    return this.form.isStudentEmployeeTabComplete();
  }

  public get injuryTabComplete() {
    return this.form.isInjuryTabComplete();
  }

  public get witnessTabComplete() {
    return this.form.isWitnessTabComplete();
  }

  public get supervisorTabComplete() {
    return this.form.isSupervisorTabComplete();
  }

  public get fieldCoordinatorTabComplete() {
    return this.form.isFieldCoordinatorTabComplete();
  }

  public setTabIndex(id: number): void {
    this.tabIndex = id;
  }

  public submit() {
    const dispatchString: string = this.edit || this.view ? 'injury/editInjuryForm' : 'injury/addInjuryForm';
    this.$store
      .dispatch(dispatchString, this.form)
      .then((r: any) => {
        if (!r.success) {
          bootbox.alert(r.message);
        } else {
          const formId: number = r.form.id;
          const createdPromises: Array<Promise<any>> = [];
          if (this.removedDocuments.length > 0) {
            this.removedDocuments.forEach((id: number) => {
              const deletedDoc: Promise<any> = this.$store.dispatch('injury/removeInjuryDocument', id);
              createdPromises.push(deletedDoc);
            });
          }
          if (this.documents.length > 0) {
            this.documents.forEach((inj: InjuryDocument) => {
              if ((inj.id === undefined || inj.id === null) && inj.file !== undefined && inj.file !== null) {
                inj.injuryFormId = formId;
                const uploadedDoc: Promise<any> = this.$store.dispatch('injury/addInjuryDocument', inj);
                createdPromises.push(uploadedDoc);
              }
            });
          }
          Promise.all(createdPromises)
            .then(() => {
              this.$store.dispatch('injury/loadInjuryDocuments', true).then(() => {
                this.$store.dispatch('injury/loadInjuryForms', true).then(() => {
                  bootbox.alert('Saved.', () => {
                    this.updateForm();
                    this.$router.push('/forms/injuryreportform/' + r.form.id);
                  });
                });
              });
            })
            .catch((e) => {
              bootbox.alert(e);
            });
        }
      })
      .catch((e) => {
        bootbox.alert(e);
      });
  }

  public mounted() {
    this.updateForm();
  }

  public updateForm() {
    if (this.id !== undefined && !isNaN(this.id)) {
      this.$store.dispatch('injury/loadInjuryDocuments').then(() => {
        this.$store.dispatch('injury/loadInjuryForms').then(() => {
          const injuryForm: InjuryForm | undefined = this.$store.getters['injury/getInjuryFormById'](this.id);
          if (injuryForm !== undefined) {
            this.form = injuryForm;
            if (this.edit) {
              this.lookupPressed = true;
              this.studentFound = true;
            }
            this.documents.splice(0);
            if (this.form.injuryDocumentIds !== null && this.form.injuryDocumentIds !== undefined && this.form.injuryDocumentIds.length > 0) {
              this.form.injuryDocumentIds.forEach((id: number) => {
                const injDocument = this.$store.getters['injury/getInjuryDocumentById'](id);
                if (injDocument !== undefined && injDocument !== null) {
                  this.documents.push(injDocument);
                }
              });
            }
          } else if (this.edit || this.view) {
            bootbox.alert('Injury Report Form was not found.', () => {
              this.$router.push('/forms');
            });
          }
        });
      });
    }
  }

  public validateForm(): boolean {
    if (!_(['employee', 'student']).contains(this.form.injuredPerson)) {
      bootbox.alert('Please select either Employee or Student.');
      return false;
    }

    const errors: string[] = [];

    const form = this.form || {};
    const studentForm = 'student' === form.injuredPerson;
    const employeeForm = 'employee' === form.injuredPerson;
    const employee = (form.employee || {}) as any;
    const student = (form.student || {}) as any;

    const studentId = (student.dolId || '').trim();
    const firstName = (student.firstName || '').trim();
    const lastName = (student.lastName || '').trim();

    if (employeeForm && !employee.userId) {
      errors.push('An employee must be selected.');
    }

    if (studentForm && 7 !== studentId.length) {
      errors.push('The Student ID is required.');
    }

    if (studentForm && !this.studentFirstNameIsValid) {
      errors.push('A valid First Name is required.');
    }

    if (studentForm && false === this.studentMiddleNameIsValid) {
      errors.push('Please enter a valid Middle Name.');
    }

    if (studentForm && !this.studentLastNameIsValid) {
      errors.push('A valid Last Name is required.');
    }

    if (!form.jobCorpsCenterId) {
      errors.push('A Job Corps Center must be selected.');
    }

    const injury = (form.injury || {}) as any;

    if (_(injury.date).isEmpty()) {
      errors.push('The date of the injury must be provided.');
    }

    if (!this.supervisorFirstNameIsValid) {
      errors.push(`The Supervisor's First Name is required.`);
    }

    if (!this.supervisorLastNameIsValid) {
      errors.push(`The Supervisor's Last Name is required.`);
    }

    if (!this.supervisorTitleIsValid) {
      errors.push(`The Supervisor's Title is required.`);
    }

    if (!this.supervisorPhoneIsValid) {
      errors.push(`The Supervisor's Office Phone is required.`);
    }

    const isValid = _(errors).isEmpty();

    if (!isValid) {
      bootbox.alert(`
      <div style="font-weight:bold">Please correct the following:</div>
      <div style="padding-top: 10px">
        <ol>
          <li>${errors.join('</li><li>')}</li>
        </ol>
      </div>`);
    }

    return isValid;
  }

  public setSave() {
    if (!this.validateForm()) {
      return;
    }

    this.form.action = 'save';
    this.submit();
  }

  public setSubmit() {
    this.form.action = 'submit';
    this.submit();
  }

  public setEdit() {
    this.form.action = 'edit';
    this.submit();
  }

  public setReview() {
    this.form.action = 'review';
    this.submit();
  }

  public setComplete() {
    this.form.action = 'complete';
    this.submit();
  }

  public setInvalid() {
    if (confirm('Mark form as Invalid?')) {
      this.form.action = 'invalidate';
      this.submit();
    }
  }

  public setReinstate() {
    if (confirm('Remove Invalid status?')) {
      this.form.action = 'reinstate';
      this.submit();
    }
  }

  get canBeReviewed(): boolean {
    let canBeReviewed: boolean = false;
    if (this.form.status === 'Submitted') {
      canBeReviewed = true;
    }
    return canBeReviewed;
  }

  get canBeCompleted(): boolean {
    let canBeCompleted: boolean = false;
    if (this.form.status === 'Reviewed') {
      canBeCompleted = true;
    }
    return canBeCompleted;
  }

  get canBeInvalidated(): boolean {
    if (this.form.status === undefined || this.form.status !== 'Invalid') {
      return authorize(Office);
    } else {
      return false;
    }
  }

  get canBeReinstated(): boolean {
    if (this.form.status === undefined || this.form.status === 'Invalid') {
      return authorize(Office);
    } else {
      return false;
    }
  }

  get isNotSubmitted(): boolean {
    let isNotSubmitted: boolean = false;
    if (this.form.status === undefined || this.form.status === 'Saved') {
      isNotSubmitted = true;
    }
    return isNotSubmitted;
  }

  public get authorizeAction(): boolean {
    let authorized: boolean = false;
    if (this.form.actionLevel !== undefined) {
      authorized = authorize(authorizeMap(this.form.actionLevel));
    }
    return authorized;
  }

  public get canSubmitReview(): boolean {
    const validations: boolean[] = [this.studentTabComplete, this.injuryTabComplete, this.witnessTabComplete, this.supervisorTabComplete];

    if (this.authorizeAction && this.canBeReviewed) {
      validations.push(this.fieldCoordinatorTabComplete);
    }

    return validations.every((i) => true === i);
  }

  public async checkStudentDolId(dolId: string): Promise<StudentProfile | null> {
    try {
      const { data } = await api().post('student/dolId/search', { dolId });
      const { student } = data;

      return !!student ? new StudentProfile(student as IStudentProfile) : null;
    } catch (err) {
      console.error(err);
      return null;
    }
  }

  public async checkStudentId() {
    const dolId = (((this.form || {}).student || {}).dolId || '').trim();

    if (7 !== dolId.length) {
      return bootbox.alert('Student ID should be 7 digits.');
    }

    const student: StudentProfile | null = await this.checkStudentDolId(dolId);

    if (_(student).isNull()) {
      return bootbox.alert(`No student was found with ID: ${dolId}`, () => {
        if (this.form && this.form.student) {
          this.lookupPressed = true;
          this.addingAsNewStudent = true;
          this.studentFound = false;
        }
      });
    }

    const profile = (student || {}) as StudentProfile;

    if (!!this.form.student) {
      this.form.student.firstName = profile.firstName;
      this.form.student.middleName = profile.middleName;
      this.form.student.lastName = profile.lastName;
      this.form.student.suffix = profile.suffix;
      this.form.student.studentId = profile.id;
      this.form.student.jobCorpCenterId = profile.jobCorpsCenterId;
    }

    this.form.jobCorpsCenterId = profile.jobCorpsCenterId;
    this.lookupPressed = true;
    this.studentFound = true;
    this.addingAsNewStudent = null;
  }

  public get newStudentFeedback(): string {
    return this.addingAsNewStudent && !this.studentFound ? 'Student ID was not found. Will be added as a new student.' : '';
  }

  public setupUser(userId: number | undefined) {
    if (userId === undefined && this.form && this.form.employee) {
      this.form.employee.firstName = undefined;
      this.form.employee.middleName = undefined;
      this.form.employee.lastName = undefined;
      this.form.employee.suffix = undefined;
      this.form.employee.title = undefined;
      this.form.employee.cellPhone = undefined;
      this.form.employee.userId = undefined;
      this.form.employee.ubcId = undefined;
      this.form.jobCorpsCenterId = undefined;
    } else if (userId !== undefined && this.form && this.form.employee) {
      const user: UserProfile | undefined = this.$store.getters.getUserProfileById(userId);
      if (user !== undefined) {
        this.form.employee.firstName = user.firstName;
        this.form.employee.middleName = user.middleName;
        this.form.employee.lastName = user.lastName;
        this.form.employee.suffix = user.suffix;
        this.form.employee.title = user.title;
        this.form.employee.cellPhone = user.cellPhoneNumber ? phoneFormatter(user.cellPhoneNumber.toString(), {}) : undefined;
        this.form.employee.userId = user.id;
        this.form.employee.ubcId = user.ubcId;
        this.form.jobCorpsCenterId = user.jobCorpsCenterPrimaryId;
      } else {
        this.form.employee.firstName = undefined;
        this.form.employee.middleName = undefined;
        this.form.employee.lastName = undefined;
        this.form.employee.suffix = undefined;
        this.form.employee.title = undefined;
        this.form.employee.cellPhone = undefined;
        this.form.employee.userId = undefined;
        this.form.employee.ubcId = undefined;
        this.form.jobCorpsCenterId = undefined;
      }
    }
  }

  public get usersList(): UserProfile[] {
    return _(this.$store.getters.getAvailableUserList)
      .chain()
      .sortBy((u) => u.firstName)
      .sortBy((u) => u.lastName)
      .value();
  }

  public get debugValidation(): string[] {
    if (this.form && this.form.supervisorReport) {
      return this.form.supervisorTabComplete();
    }
    return [];
  }

  public downloadFile(id: string | number) {
    // TODO: use the downloader
    window.open('/api/v1/injurydocument/' + id);
  }

  public removeFile(index: number) {
    if (index > -1) {
      const doc: InjuryDocument = this.documents[index];
      bootbox.confirm(`Are you sure you want to remove <strong>${doc.filename}?</strong>`, (yes) => {
        if (yes) {
          if (!!doc.id) {
            this.removedDocuments.push(doc.id);
          }

          this.documents.splice(index, 1);
        }
      });
    }
  }

  public get fileDownloadFields() {
    return [
      {
        key: 'filename',
        label: 'Filename'
      },
      {
        key: 'actions',
        label: ''
      }
    ];
  }

  public addFileToArray() {
    if (this.file !== null && this.file !== undefined) {
      this.documents.push({
        file: this.file,
        filename: this.file.name
      });
    }
    this.$refs.fileInput.reset();
  }

  public async downloadPdf(): Promise<void> {
    try {
      await binaryDownload('GET', `/api/v1/report/injury/${this.id}`);
    } catch (err) {
      bootbox.alert(err.message);
    }
  }
}
